import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.find.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import scroll from 'quasar/src/utils/scroll.js';;
var getScrollTarget = scroll.getScrollTarget,
    setScrollPosition = scroll.setScrollPosition;
import { colorLuminance } from "../../utils/utils";
import { calculateRating, getEmojiOptions, getExistingRatingByOption } from "./menuInsightHelpers/ratings";
import { shouldShowSubquestion as _shouldShowSubquestion } from "./menuInsightHelpers/rendering";
export default {
  name: 'MenuInsightFamilyGroup',
  props: {
    activeCategory: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    activeSubcategory: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    allProductsAsInlineDishes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    dishes: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    // categoriesLoading: Boolean,
    // subcategoriesLoading: Boolean,
    productsLoading: {
      type: Boolean,
      default: false
    },
    question: {
      type: Object,
      required: true
    },
    response: {
      type: Array,
      required: true
    },
    searchResults: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    searchResultsLoading: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      modal: false,
      activeDish: null,
      modals: {},
      searchBox: false,
      search: '',
      topLevelSearchActive: false,
      isLoading: this.searchResultsLoading
    };
  },
  computed: {
    bgImage: function bgImage() {
      return {
        backgroundImage: "url(".concat(this.$store.getters['theme/bgImage'], ")")
      };
    },
    activeSubcategoriesByCategory: function activeSubcategoriesByCategory() {
      return this.activeSubcategory && this.activeSubcategory.ref ? [this.activeSubcategory] : [];
    },
    emojiOptions: function emojiOptions() {
      return getEmojiOptions(this.question);
    },
    selectedDishes: function selectedDishes() {
      var _this = this;

      var allDishes = this.allProductsAsInlineDishes;
      return allDishes.filter(function (option) {
        return !!_this.response.find(function (r) {
          return r.ref === option.ref;
        });
      });
    },
    getModalDishes: function getModalDishes() {
      return this.allProductsAsInlineDishes;
    },
    overlay: function overlay() {
      return {
        color: colorLuminance(this.$store.getters['theme/theme'].primaryColor, -0.5)
      };
    }
  },
  watch: {
    search: function search(val) {
      this.isLoading = !!val && val.length > 0;
      this.$emit('search', val);
    },
    searchResultsLoading: function searchResultsLoading(val) {
      this.isLoading = val;
    }
  },
  methods: {
    scrollToElement: function scrollToElement(id) {
      var el = document.getElementById(id);
      var target = getScrollTarget(el);
      var offset = el.offsetTop;
      var duration = 300;
      setScrollPosition(target, offset - 200, duration);
    },
    selectedCategory: function selectedCategory(item) {
      this.modal = true;
      this.$emit('category-selected', item);
    },
    subcategorySelected: function subcategorySelected(item) {
      this.$emit('subcategory-selected', item); // this.scrollToElement('subcategory' + item.ref) // deactivated while filtering
    },
    handleFCFakeClick: function handleFCFakeClick(item) {
      // this is to handle weird event propagation stuff related to the fact that fib-emoji was originally fired a 'click' event on 'input'
      this.openModal(item);
    },
    handleEmojiClicked: function handleEmojiClicked(value, item) {
      // For some reason this doesn't end up getting called in circumstances where it is newly selected, which is strange, but I won't rely on this to implement a solution here as it shouldn't be the case.  I won't bother fixing this now as no functionality currently requires this call to be made in those cases, but it is worth keeping note of.
      // if no item or value provided, ditch out
      if (!value || !item) {
        return;
      } // if follow up questions allowed, ditch out, (although in the future this functionality might be desied)


      if (this.question.followUpQuestion) {
        return;
      } // double check that there is an existing rating for item, and that the aspectRatingId matches the value provided


      var rating = getExistingRatingByOption(item, this.response); // if no rating or no match, ditch out

      if (!rating || rating.aspectRatingId !== value) {
        return;
      } // clear out rating


      this.clearDish(item);
    },
    handleResponse: function handleResponse(value, context) {
      if (context.source === 'selectedDishEmoji') {
        // Logger.debug('selectedDishEmoji input detected')
        // expect context to contain: item
        if (!context.item) {
          return;
        }

        return; // not currently supporting inline selection in the 'selected dishes' area
      }

      this.$emit('input', calculateRating(value, context, this.response));
    },
    openModal: function openModal(dish) {
      // if no dish provided, ditch out
      if (!dish) {
        return;
      } // if no follow up questions allowed, ditch out


      if (!this.question.followUpQuestion) {
        return;
      }

      this.$set(this.modals, dish.id, true);
    },
    closeModal: function closeModal(dish) {
      this.$set(this.modals, dish.id, false);
    },
    getComments: function getComments(dish) {
      if (!dish || !dish.subQuestions || !dish.subQuestions.length) {
        return false;
      }

      var rating = this.response.find(function (r) {
        return r.ref === dish.ref;
      });
      var hasComments = rating ? dish.subQuestions.some(function (subQuestion) {
        return subQuestion && subQuestion.type === 'fib-comments' && rating.comment;
      }) : false;
      return hasComments;
    },
    getFibEmojiValue: function getFibEmojiValue(option) {
      var rating = this.response.find(function (r) {
        return r.ref === option.ref;
      });
      return rating ? rating.aspectRatingId : null;
    },
    getSubQuestionValue: function getSubQuestionValue(subQuestion, option) {
      var rating = this.response.find(function (r) {
        return r.ref === option.ref;
      });

      if (!rating) {
        return null;
      }

      var val = null;

      switch (subQuestion.type) {
        case 'fib-comments':
          val = rating.comment;
          break;

        case 'fib-select-option':
          val = rating.tags;
          break;
      }

      return val;
    },
    clearDish: function clearDish(dish) {
      // if no dish, ditch out
      if (!dish) {
        return;
      } // if no dish ref, or dish id, ditch out


      var id = dish.ref || dish.id;

      if (!id) {
        return;
      }

      this.$emit('clear', id);
      this.$set(this.modals, id, false);
    },
    modalSaveButtonDisabled: function modalSaveButtonDisabled(dish) {
      var dishRated = this.response.find(function (r) {
        return r.ref === dish.ref;
      });
      var allRequiredQuestionsAnswered = true;

      if (dish.subQuestions) {
        allRequiredQuestionsAnswered = dish.subQuestions.every(function () {
          // TODO - This needs sorting out properly
          // if (!subQuestion.required) return true
          // const answer = this.response.find(r => r.ref = dish.ref)
          // let answered = !!answer
          // if (Array.isArray(answer) && !answer.length) {
          //   answered = false
          // }
          // return answered
          return true;
        });
      }

      return !dishRated || !allRequiredQuestionsAnswered;
    },
    shouldShowSubquestion: function shouldShowSubquestion(subQuestion, option) {
      return _shouldShowSubquestion(subQuestion, option, this.response);
    },
    hideSubQuestionComponent: function hideSubQuestionComponent(subQuestion) {
      var _subQuestion$showIf;

      if (subQuestion !== null && subQuestion !== void 0 && (_subQuestion$showIf = subQuestion.showIf) !== null && _subQuestion$showIf !== void 0 && _subQuestion$showIf.hide) {
        return true;
      }

      return false;
    },
    onClearSearch: function onClearSearch() {
      this.topLevelSearchActive = false;
      this.$emit('clear-search');
    }
  }
};